import { Box, Button, Collapsible, DateInput, FileInput, Footer, FormField, Heading, RadioButtonGroup, Select, TextArea,Text, TextInput, Anchor } from 'grommet';
import { Close, FormDown, FormNext, Print } from 'grommet-icons';
import React, { Component } from 'react';
import './index.css';

export interface INewInvoiceProps {
//Here we pass the Props Interface
setToast : Function
}

export interface INewInvoiceState {
//here we pass the State Interface
invoiceType : "Λιανικής" | "Τιμολόγιο",
formData : any,
collapsible1: boolean,
collapsible2: boolean,
collapsible3: boolean,
collapsible4: boolean,
}

//class ComponentName Component<PropsInterface, StateInterface>
	class NewInvoice extends Component<INewInvoiceProps, INewInvoiceState> {

		constructor(props:INewInvoiceProps){
		super(props)

		this.state = {
		invoiceType : "Λιανικής",
		formData : {

		},
		collapsible1: true,
collapsible2:true,
collapsible3:true,
collapsible4: true,
		}
		}

		setInvoiceType(e : any){
		this.setState({invoiceType : e})
		}


		//Add style here
		style = {
		};




		// After the component did mount, we set the state.
		componentDidMount() {
		}

		render() {
		return (<>
		<Box pad={"0 0 100 0"}>
			<Box justify='center' flex direction='row' border="horizontal">
				<Heading size='large' level={"3"}>Νέο Παραστατικό</Heading>
			</Box>
			<Box border="bottom" background={"blue"}>
					<Heading level={"4"} alignSelf='center' color={"white"} >Είδος Παραστατικού</Heading>
			</Box>
			<RadioButtonGroup flex direction='row' alignSelf='center' justify='center' margin={"20px"}
			name="invoiceType" options={['Λιανικής', 'Τιμολόγιο' ]} value={this.state.invoiceType}
			onChange={(event)=> this.setInvoiceType(event.target.value)}
			/>
			<Box border="top" background={"blue"} hoverIndicator={{background:"dark"}} justify='center' align='center' flex direction='row' onClick={()=>{this.setState({collapsible1 : !this.state.collapsible1})}}>
				<Heading level={"4"} alignSelf='center'>Στοιχεία Πελάτη</Heading>
				{this.state.collapsible1  ? 
				<FormDown />
				:
				<FormNext/>		}
			</Box>
			<Collapsible open={this.state.collapsible1}>
				<Box border="horizontal" pad={"24px"}>
					<Box>
						<FormField label="ΑΦΜ"   >
							<TextInput placeholder="Εισάγετε ΑΦΜ" />
						</FormField>
					</Box>
					<Box>
						<FormField label="ΚΩΔΙΚΟΣ ΔΕΗ"   >
							<TextInput placeholder="Εισάγετε Κωδικό ΔΕΗ" />
						</FormField>
					</Box>
					<FormField label="ΕΠΩΝΥΜΙΑ">
						<TextInput placeholder="Εισάγετε Επωνυμία" />
					</FormField>
					<FormField label="ΔΙΕΥΘΥΝΣΗ">
						<TextInput placeholder="Εισάγετε Διεύθυνση" />
					</FormField>
					<FormField label="ΠΟΛΗ">
						<TextInput placeholder="Εισάγετε Πόλη" />
					</FormField>
					<FormField label="Τ.Κ.">
						<TextInput placeholder="Εισάγετε Τ.Κ." />
					</FormField>
					<FormField label="ΔΟΥ">
						<TextInput placeholder="Εισάγετε ΔΟΥ" />
					</FormField>
					<FormField label="ΤΗΛΕΦΩΝΟ">
						<TextInput placeholder="Εισάγετε Τηλέφωνο" />
					</FormField>
					<FormField label="ΔΙΕΥΘ. ΠΑΡΑΔΟΣΗΣ">
						<TextInput placeholder="Εισάγετε Διεύθ. Παραδοσης" />
					</FormField>
					<Box pad={"10px"}>

						<Heading level={"5"}  color={"dark"}>Σημειώσεις</Heading>
						<TextArea
						placeholder="Σημείωσεις / Σχόλια"
						value={""}
						onChange={event => {}}
						/>
					</Box>
						<Box pad={"10px"}>
						<Heading level={"5"}  color={"dark"}>Ενεργειακό Προϊόν</Heading>
						<Select
    					  options={['DieselHeat', 'Gas']}
    					  value={'DieselHeat'}
    					  onChange={()=>{}}
						  />
					</Box>
				</Box>
			</Collapsible>
			<Box border="bottom" background={"blue"} hoverIndicator={{background:"dark"}} flex direction='row' align='center' justify='center' onClick={()=>{this.setState({collapsible2 : !this.state.collapsible2})}}>
				<Heading level={"4"} alignSelf='center'>Μετρήσεις</Heading>
				{this.state.collapsible2  ? 
				<FormDown />
				:
				<FormNext/>		
				}
			</Box>
			<Collapsible open={this.state.collapsible2}>
				<Box border="bottom" pad={"24px"}>
					<FormField label="ΠΡΟΜΕΤΡΗΣΗ">
						<TextInput placeholder="Εισάγετε ΠΡΟΜΕΤΡΗΣΗ (ΕΚ.)" type={"number"} min={0}/>
					</FormField>
					<FormField label="ΕΠΙΜΕΤΡΗΣΗ">
						<TextInput placeholder="Εισάγετε ΕΠΙΜΕΤΡΗΣΗ (ΕΚ.)" type={"number"} min={0}/>
					</FormField>
				</Box>
			</Collapsible>
			<Box border="bottom" background={"blue"} hoverIndicator={{background:"dark"}} flex direction='row' align='center' justify='center'   onClick={()=>{this.setState({collapsible3 : !this.state.collapsible3})}}>
				<Heading level={"4"} alignSelf='center'> Ποσότητα & Τιμή</Heading>
				{this.state.collapsible3  ? 
				<FormDown />
				:
				<FormNext/>	}	
			</Box>
			<Collapsible open={this.state.collapsible3} >
				<Box border="bottom" pad={"24px"}>
					<FormField label="ΠΟΣΟΤΗΤΑ">
						<TextInput placeholder="Εισάγετε Ποσότητα (Λίτρα)" type={"number"} min={0}/>
					</FormField>
					<FormField label="ΤΙΜΗ ΛΙΤΡΟΥ (ΜΕ ΦΠΑ)">
						<TextInput placeholder="Εισάγετε Τιμή Λίτρου" type={"number"} min={0}/>
					</FormField>
				</Box>
			</Collapsible>
			<Box border="bottom" background={"blue"} hoverIndicator={{background:"dark"}} flex direction='row' align='center' justify='center' margin={this.state.collapsible4 ? "0" : "0 0 120px 0"}   onClick={()=>{this.setState({collapsible4 : !this.state.collapsible4})}}>
				<Heading level={"4"} alignSelf='center'> Ποσό & Τρόπος Πληρωμής</Heading>
				{this.state.collapsible4  ? 
				<FormDown />
				:
				<FormNext/>	}	
			</Box>
			<Collapsible open={this.state.collapsible4} >
				<Box border="bottom" pad={"24px"} margin={"0 0 60px 0"}>
					<FormField label="ΠΟΣΟ ΜΕΤΡΗΤΑ">
						<TextInput placeholder="0" type={"number"} min={0}/>
					</FormField>
					<FormField label="ΠΟΣΟ ΚΑΡΤΑ">
						<TextInput placeholder="0" type={"number"} min={0}/>
					</FormField>
					<FormField label="ΠΟΣΟ ΚΑΤΑΘΕΣΗΣ">
						<TextInput placeholder="0" type={"number"} min={0}/>
					</FormField>
					<FormField label="ΠΙΣΤΩΣΗ">
						<TextInput placeholder="0" type={"number"} min={0}/>
					</FormField>
				</Box>
			</Collapsible>
		</Box>
		 <Box style={{position : "fixed" , bottom:"0" , width : "100%" }}>
			<Footer background="brand" pad="medium" height={"40px"} flex direction='row' justify='evenly'>
			  <Button onClick={()=>{this.props.setToast("Επιτυχία", "normal" , "Επιτυχημένη καταχώρηση",true)}} ><Print color="green"/></Button>
			  <Button><Close color="red"/></Button>
			</Footer>
			</Box>
			</>
		);
		}
		}

		export default NewInvoice;